var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v20h-20z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ed7226",
    fillRule: "nonzero",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 18c-4.96279905 0-9-4.0372009-9-9 0-4.96279905 4.03720095-9 9-9 4.9627991 0 9 4.03720095 9 9 0 4.9627991-4.0372009 9-9 9zm0-16.875c-4.34248351 0-7.875 3.53251649-7.875 7.875 0 4.3424835 3.53251649 7.875 7.875 7.875 4.3424835 0 7.875-3.5325165 7.875-7.875 0-4.34248351-3.5325165-7.875-7.875-7.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.9375 13.8750458c-.1440582 0-.2879791-.0547943-.3975678-.1650696l-3.93749996-3.93750001c-.10574339-.10574339-.16493224-.24897765-.16493224-.3974304v-5.25009158c0-.31050108.25199891-.5625.5625-.5625s.5625.25199892.5625.5625v5.01676942l3.7725678 3.77256777c.2197265.2197266.2197265.5759582 0 .7956848-.1095887.1102753-.2535096.1650696-.3975678.1650696z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClock);
export default __webpack_public_path__ + "static/media/ic_clock.8c7cc88996ed8d5a08cfd9bd9e295716.svg";
export { ForwardRef as ReactComponent };